import { useState } from 'react';
import { Button } from '../ui/button';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../ui/alert-dialog';

export interface CustomGroupFormActionsProps {
  onSave: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  saveLabel?: string;
  cancelLabel?: string;
  deleteLabel?: string;
  isSaving?: boolean;
  isDeleting?: boolean;
  disabled?: boolean;
  showDelete?: boolean;
  showCancel?: boolean;
  deleteConfirmTitle?: string;
  deleteConfirmDescription?: string;
}

export function CustomGroupFormActions({
  onSave,
  onCancel,
  onDelete,
  saveLabel = 'Save Changes',
  cancelLabel = 'Cancel',
  deleteLabel = 'Delete',
  isSaving = false,
  isDeleting = false,
  disabled = false,
  showDelete = false,
  showCancel = true,
  deleteConfirmTitle = 'Are you sure?',
  deleteConfirmDescription =
    'This action cannot be undone. This will permanently delete this custom group and remove all sensor assignments.',
}: CustomGroupFormActionsProps) {
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleDeleteConfirm = () => {
    setIsDeleteDialogOpen(false);
    onDelete?.();
  };

  return (
    <div className='flex items-center justify-between gap-2'>
      <div className='flex items-center gap-2'>
        {saveLabel && (
          <Button
            onClick={onSave}
            disabled={disabled || isSaving || isDeleting}
          >
            {isSaving ? 'Saving...' : saveLabel}
          </Button>
        )}

        {showCancel && onCancel && (
          <Button
            variant='outline'
            onClick={onCancel}
            disabled={disabled || isSaving || isDeleting}
          >
            {cancelLabel}
          </Button>
        )}
      </div>

      {showDelete && onDelete && (
        <AlertDialog open={isDeleteDialogOpen} onOpenChange={setIsDeleteDialogOpen}>
          <AlertDialogTrigger asChild>
            <Button
              variant='destructive'
              disabled={disabled || isSaving || isDeleting}
            >
              {isDeleting ? 'Deleting...' : deleteLabel}
            </Button>
          </AlertDialogTrigger>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{deleteConfirmTitle}</AlertDialogTitle>
              <AlertDialogDescription>
                {deleteConfirmDescription}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel>Cancel</AlertDialogCancel>
              <AlertDialogAction onClick={handleDeleteConfirm}>
                Delete
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      )}
    </div>
  );
}
